import React, { useContext } from 'react'
import { reportDataType } from '@/enums/reportDataType'
import { InputEditorFunc } from '@/components/report-tables/editors/fInputEditor'
import { DateTimeEditorFunc } from '@/components/report-tables/editors/fDateTimeEditor'
import { IntEditorFunc } from '@/components/report-tables/editors/fIntEditor'
import { FloatEditorFunc } from '@/components/report-tables/editors/fFloatEditor'
import { FloatPercentageEditorFunc } from '@/components/report-tables/editors/fFloatPercentageEditor'
import { IntPercentageEditorFunc } from '@/components/report-tables/editors/fIntPercentageEditor'
import { BoolEditorFunc } from '@/components/report-tables/editors/fBoolEditor'
import { EditorContext } from '@/components/report-tables/core/table'
const reportDataTypeEnum = reportDataType.enum

export function CellEditor (props) {
  const { onChange } = useContext(EditorContext)
  const { reportDataType } = props
  props = { ...props, onChange }
  switch (reportDataType) {
    case reportDataTypeEnum.String:
      return <InputEditorFunc {...props} />
    case reportDataTypeEnum.Integer:
    case reportDataTypeEnum.NumberUnformatted:
      return <IntEditorFunc {...props} />
    case reportDataTypeEnum.Number:
      return <FloatEditorFunc {...props} />
    case reportDataTypeEnum.PercentageDouble:
      return <FloatPercentageEditorFunc {...props} />
    case reportDataTypeEnum.PercentageInt:
      return <IntPercentageEditorFunc {...props} />
    case reportDataTypeEnum.Bool:
      return <BoolEditorFunc {...props} />
    case reportDataTypeEnum.Date:
      return <DateTimeEditorFunc {...props} />
    case reportDataTypeEnum.NoType:
    default:
      return null
  }
}



// WEBPACK FOOTER //
// ./src/components/report-tables/editors/index.js